import { Component, OnInit, ViewChild } from '@angular/core';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { Models } from '@ibexfusion/models';
import { DataTableComponent } from '../../../components/data-table/data-table.component';
import { GroupHasProfileService } from '@services/groups/group-has-profile.service';
import { ProfileService } from '@services/profiles/profile.service';
import { GroupService } from '@services/groups/group.service';

@Component({
    selector: 'app-group-participants-manager',
    templateUrl: './group-participants-manager.component.html',
    styleUrls: ['./group-participants-manager.component.scss'],
    providers: [GroupHasProfileService, ProfileService, GroupService],
    standalone: false
})
export class GroupParticipantsManagerComponent implements OnInit {

  @ViewChild(DataTableComponent) table: DataTableComponent;

  title = 'Participants of the Group ';
  dataProviderParams: any;
  pageActions: PageAction[];
  columns = [{ prop: 'firstName' }, { prop: 'lastName' }, { prop: 'email' }];

  currentSearchTerm: string;

  filteredProfiles: Models.Profile[];
  groupHasProfiles: Models.GroupHasProfile[];

  selectedGroupId: number;

  constructor(
    public groupHasProfilesService: GroupHasProfileService, private profileService: ProfileService, private route: ActivatedRoute, private router: Router,
    private snackbar: SnackbarService, private groupService: GroupService
  ) {
  }

  get filteredProfileIds(): string[] {
    if (!this.filteredProfiles) {
      return [];
    }
    const profileIds = [];
    for (const profile of this.filteredProfiles) {
      profileIds.push(profile.ProfileID);
    }

    return profileIds;
  }

  get profileIdsInUse(): { string: boolean } {
    if (!this.groupHasProfiles) {
      return <any>{};
    }
    const profileIdsInUse = {};
    for (const groupHasProfile of this.groupHasProfiles) {
      profileIdsInUse[groupHasProfile.ProfileID] = true;
    }
    return <any>profileIdsInUse;
  }

  ngOnInit() {
    this.selectedGroupId = this.route.snapshot.params['id'];
    this.groupService.get(this.selectedGroupId.toString()).then(group => {
      this.title = !!group ? 'Manage Participants of Group: ' + group.name : this.title;
    });
    this.dataProviderParams = { GroupID: this.selectedGroupId };
    this.createPageActions();
    this.profileService.find(0, 100, { $and: [{ isAnonymous: 0 }, { userType: 'ibexfusion' }] }).then(result => {
      this.filteredProfiles = result.data;
      console.log('filtered profiles: ', result);
      this.groupHasProfilesService.find(0, 20, { ProfileID: { $in: this.filteredProfileIds }, GroupID: this.selectedGroupId }).then(groupHasProfilesResult => {
        console.log('group has profiles result: ', groupHasProfilesResult);
        this.groupHasProfiles = groupHasProfilesResult.data;
      });
    });
  }

  filterProfiles(value: string) {
    this.profileService.find(0, 20, {
      $and: [
        { isAnonymous: 0 },
        { userType: 'ibexfusion' },
        {
          $or: [
            { firstName: { $like: '%' + value + '%' } },
            { lastName: { $like: '%' + value + '%' } },
            { nickName: { $like: '%' + value + '%' } }
          ]
        }
      ]
    }).then(result => {
      this.filteredProfiles = result.data;
      this.groupHasProfilesService.find(0, 20, { ProfileID: { $in: this.filteredProfileIds }, GroupID: this.selectedGroupId }).then(groupHasProfilesResult => {
        this.groupHasProfiles = groupHasProfilesResult.data;
      });
    });
  }

  addProfile(event: any) {
    this.currentSearchTerm = '';
    const data = new Models.GroupHasProfile();
    data.populateFromJSON({
      ID: null,
      ProfileID: event.option.value,
      GroupID: this.selectedGroupId
    });
    this.groupHasProfilesService.create(data).then(result => {
      if (!result || !result.ProfileID) {
        this.snackbar.error('Could not add Profile');
        return;
      }
      this.table.refresh();
    });
  }

  onDelete(event: any) {
    this.groupHasProfilesService.remove(event.row.ID).then(result => {
      this.table.refresh();
    });
  }

  createPageActions() {
    this.pageActions = [
      new PageAction({
        icon: 'subdirectory_arrow_left',
        title: 'Detail',
        callback: () => {
          this.router.navigate(['groups', this.route.snapshot.params['id']]);
        }
      })
    ];
  }
}
